<template>

    <b-card>

        <b-row>

            <b-col sm="6" md="4">

                <b-form-select v-model="type">

                    <option value="unmatched">Unmatched Pairs</option>
                    <option value="enrolled">Enrolled Pairs</option>
                    <option value="unenrolled">Unenrolled Pair</option>
                </b-form-select>
            </b-col>
            <b-col sm="6" md="4">

                <carrier-dropdown v-model=" carrier "></carrier-dropdown>
            </b-col>
        </b-row>

        <b-row class="my-2">

            <b-col sm="6" class="d-flex align-items-center">

                {{ totalRows }} Records
            </b-col>
            <b-col sm="6" class="d-flex align-items-center justify-content-end">

                <b-button variant="success" @click=" exportXls() " :disabled=" loading " class="mr-1 my-1"><i class="fa fa-file-excel-o"></i> Export to Excel</b-button>
                <b-button @click=" loadTable() " variant="info" :disabled=" loading " class="my-1">Generate Report</b-button>
            </b-col>
        </b-row>

        <div class="table-responsive">

            <b-table bordered striped hover show-empty
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page=" 0 "
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy=" loading "
            >
                <template v-slot:cell(client_name)="row">

                    <a :href="`/business/clients/${row.item.client_id}`">{{ row.value }}</a>
                </template>
                <template v-slot:cell(caregiver_name)="row">

                    <a :href="`/business/caregivers/${row.item.caregiver_id}`">{{ row.value }}</a>
                </template>
            </b-table>
        </div>

        <b-row>

            <b-col class="text-right">

                {{ totalRows }} Records
            </b-col>
        </b-row>
    </b-card>
</template>

<script>

    import FormatsListData from "../../../mixins/FormatsListData";
    import EnrollmentStatuses from "../../../mixins/EnrollmentStatuses";
    import FormatsDates from "../../../mixins/FormatsDates";
    import PaginatedTable from "../../../mixins/PaginatedTable";

    export default {

        mixins: [ FormatsDates, FormatsListData, EnrollmentStatuses, PaginatedTable ],

        props: {

            defaults: {

                type     : Array,
                default  : [],
                required : false
            }
        },

        data() {

            return {

                baseUrl : `/business/reports/paired?json=1`,

                type    : this.getDefault( 'type', 'unmatched' ),
                carrier : '',

                fields  : [
                    {
                        key: 'client_name',
                        label: 'Claimant',
                        sortable: true,
                    },
                    {
                        key: 'carrier',
                        sortable: true,
                    },
                    {
                        key: 'client_policy_number',
                        label: 'Policy #',
                        sortable: true,
                    },
                    {
                        key: 'client_enrollment_status',
                        label: 'Enrollment Status',
                        sortable: true,
                        formatter: this.formatEnrollmentStatus,
                    },
                    {
                        key: 'client_service_phone',
                        label: 'Phone',
                        sortable: true,
                    },
                    {
                        key: 'client_notices_sent',
                        label: 'Notices Sent',
                        sortable: true,
                    },
                    {
                        key: 'caregiver_name',
                        label: 'Provider',
                        sortable: true,
                    },
                    {
                        key: 'caregiver_enrollment_status',
                        label: 'Enrollment Status',
                        sortable: true,
                        formatter: this.formatEnrollmentStatus,
                    },
                    {
                        key: 'caregiver_phone',
                        label: 'Phone',
                        sortable: true,
                    },
                    {
                        key: 'caregiver_notices_sent',
                        label: 'Notices Sent',
                        sortable: true,
                    },
                    {
                        key: 'caregiver_visits',
                        label: 'Visits',
                        sortable: true,
                    },
                ]
            }
        },

        mounted() {

        },

        computed: {

            appliedFilters() {

                return `&type=${this.type}&carrier=${this.carrier}`;
            },
        },

        methods: {

            async loadTable() {

                this.loading = true;
                const response = await axios.get( `${this.baseUrl}${this.appliedFilters}` );
                this.items = response.data.results.map( item => {

                    item._cellVariants = this.getCellVariants( item );
                    return item;
                });
                this.totalRows = response.data.total;
                this.loading = false;
            },

            getCellVariants(row) {

                const clientEnrolled = this.isEnrolled(row.client_enrollment_status);
                const cgEnrolled = this.isEnrolled(row.caregiver_enrollment_status);

                let variants = {};
                for(let field of Object.keys(row)) {
                    if (field.substr(0, 6) === 'client') {
                        if (clientEnrolled) {
                            variants[field] = 'success';
                            continue;
                        }
                    }
                    else if (cgEnrolled) {
                        variants[field] = 'success';
                        continue;
                    }
                    variants[field] = 'warning';
                }

                return variants;
            },

            getDefault(field, defaultValue = '') {
                if (this.defaults && this.defaults[field]) {
                    return this.defaults[field];
                }
                return defaultValue;
            },
        }
    }
</script>
